module.exports = __webpack_public_path__ + "img/empty-flag-xx.097df977.svg";